module.exports = __webpack_public_path__ + "fonts/subset-IskraFreefont.922eeb2.woff";